// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2zLuU","title":"Images45_title__27iCG","images":"Images45_images__6y15g"};